import React, { useEffect, useState } from 'react'
import { toCommas } from '../../utils/utils'
import styles from './Dashboard.module.css'
import { useHistory, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import Empty from '../svgIcons/Empty'
import Chart from './Chart'
import ChartInvoice from './ChartInvoice'
// import Donut from './Donut'
import moment from 'moment'
import { Check, Pie, Bag, Card, Clock, Frown } from './Icons'
import Spinner from '../Spinner/Spinner'
import * as api from '../../api/index'


const Dashboard = () => {

    const location = useLocation()
    const history = useHistory()
    const [inventoryStatus,setInventoryStatus] = useState(null);
    const [invoiceStatusByCurrentYearMonth,setInvoiceStatusByCurrentYearMonth] = useState(null);
    const user = JSON.parse(localStorage.getItem('profile'))
   
   



    useEffect(() => {
        const load = async () => { 
          const { data } = await api.fetchInventoryStatus(); 
          setInventoryStatus(data.results);

          const invoicedata = await api.fetchInvoiceStatusCurrentYearMonths(); 
          setInvoiceStatusByCurrentYearMonth(invoicedata?.data?.results);
         
          
        };
        load();
      }, []);

 
    
    if(!user) {
        history.push('/login')
      }

/*
      if(isLoading) {
        return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px'}}>
            <Spinner />
        </div>
      }
*/
  
      
    return (
        <div className={styles.pageContainer}>
           
    
           

            {inventoryStatus?.length !== 0 && (
            <section>

                <Chart inventoryStatus={inventoryStatus}  />
            </section>
            )}

            {invoiceStatusByCurrentYearMonth?.length !== 0 && (
            <section>

                <ChartInvoice invoiceStatusByCurrentYearMonth={invoiceStatusByCurrentYearMonth}  />
            </section>
            )}

           
        </div>
    )
}

export default Dashboard
